export default __webpack_public_path__ + "static/media/avatar_3.aacb2235.png";